import { render, staticRenderFns } from "./TinderAccountsPage.vue?vue&type=template&id=04869d6a&scoped=true"
import script from "./TinderAccountsPage.vue?vue&type=script&lang=js"
export * from "./TinderAccountsPage.vue?vue&type=script&lang=js"
import style0 from "./TinderAccountsPage.vue?vue&type=style&index=0&id=04869d6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04869d6a",
  null
  
)

export default component.exports